import type { FieldType } from '@ofmos/shared/field-types';
import type { ComponentType } from 'react';
import { useFieldContext } from '../FieldContext';
import { BooleanDisplay } from './BooleanDisplay';
import { CurrencyDisplay } from './CurrencyDisplay';
import { DateDisplay } from './DateDisplay';
import { DateTimeDisplay } from './DateTimeDisplay';
import { EmailDisplay } from './EmailDisplay';
import { FilesDisplay } from './FilesDisplay';
import { MultiSelectDisplay } from './MultiSelectDisplay';
import { NumberDisplay } from './NumberDisplay';
import { PhoneDisplay } from './PhoneDisplay';
import { RelationDisplay } from './RelationDisplay';
import { SelectDisplay } from './SelectDisplay';
import { TextDisplay } from './TextDisplay';
import { UrlDisplay } from './UrlDisplay';

/**
 * INV-12: the dispatch is a MAP, not a chain of type guards (Twenty's
 * `FieldDisplay.tsx` is a 24-branch nested ternary backed by 55 guard files -
 * adding a type there touches six places). `Record<FieldType, ...>` means a new
 * field type in `shared` fails the typecheck right here until an entry exists.
 *
 * Components are prop-less: everything comes from the FieldContext.
 */
export const FIELD_DISPLAYS: Record<FieldType, ComponentType> = {
  TEXT: TextDisplay,
  NUMBER: NumberDisplay,
  BOOLEAN: BooleanDisplay,
  DATE: DateDisplay,
  DATETIME: DateTimeDisplay,
  SELECT: SelectDisplay,
  MULTI_SELECT: MultiSelectDisplay,
  RELATION: RelationDisplay,
  EMAIL: EmailDisplay,
  PHONE: PhoneDisplay,
  URL: UrlDisplay,
  CURRENCY: CurrencyDisplay,
  FILES: FilesDisplay,
};

export function FieldDisplay() {
  const { field } = useFieldContext();
  const Display = FIELD_DISPLAYS[field.type];
  return <Display />;
}
